import React from 'react';
interface Props {
  fillColor?: string;
}
function RehabIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none">
      <g clipPath="url(#clip0_847_2984)">
        <path
          d="M5.71836 0.220312L0.218359 5.72031C-0.0753906 6.01406 -0.0753906 6.48906 0.218359 6.77969C0.512109 7.07031 0.987109 7.07344 1.27773 6.77969L1.74648 6.31094L6.30898 10.8703C6.36836 10.9297 6.42773 10.9828 6.49023 11.0359L6.59961 10.9266C6.63398 10.8922 6.65586 10.8516 6.66836 10.8047L6.97773 9.41719L2.80898 5.25156L5.24961 2.81094L8.24023 5.80156C8.29961 5.73281 8.36211 5.66719 8.42461 5.60156L9.29336 4.73281L6.30898 1.75156L6.77773 1.28281C7.07148 0.989062 7.07148 0.514063 6.77773 0.223437C6.48398 -0.0671875 6.00898 -0.0703125 5.71836 0.223437V0.220312ZM12.5621 12.5859L11.7121 12.7734L14.7184 15.7828C15.0121 16.0766 15.4871 16.0766 15.7777 15.7828C16.0684 15.4891 16.0715 15.0141 15.7777 14.7234L13.3652 12.3109C13.109 12.4328 12.8402 12.5266 12.559 12.5891L12.5621 12.5859ZM13.2184 0.220312C12.9246 0.514062 12.9246 0.989063 13.2184 1.27969L18.7184 6.78281C19.0121 7.07656 19.4871 7.07656 19.7777 6.78281C20.0684 6.48906 20.0715 6.01406 19.7777 5.72344L14.2809 0.220312C13.9871 -0.0734375 13.5121 -0.0734375 13.2215 0.220312H13.2184ZM12.9809 2.45781L9.13086 6.31094C8.76211 6.67969 8.50586 7.14844 8.39023 7.65781L7.64336 11.0203C7.59023 11.2516 7.47461 11.4641 7.30586 11.6328L4.21836 14.7203C3.92461 15.0141 3.92461 15.4891 4.21836 15.7797C4.51211 16.0703 4.98711 16.0734 5.27773 15.7797L8.36523 12.6922C8.53398 12.5234 8.74648 12.4078 8.97773 12.3547L12.3434 11.6109C12.8527 11.4984 13.3215 11.2422 13.6902 10.8703L17.5434 7.02031L16.484 5.96094L14.2496 8.19219L11.809 5.75156L14.0402 3.52031L12.9809 2.45781ZM10.1934 7.37031L10.7496 6.81094L13.1902 9.25156L12.634 9.81094C12.4652 9.97969 12.2527 10.0953 12.0215 10.1484L9.24023 10.7672L9.85898 7.98594C9.91211 7.75469 10.0277 7.54219 10.1965 7.37344L10.1934 7.37031Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_2984">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RehabIcon;
